import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext, SET_STYLE } from '../context/AppContext';
import { useUrlState } from '../utils/urlState';
import { MobileView, BrowserView } from 'react-device-detect';
import imgEng from '../images/ui_buttons/style_english.png';
import imgFor from '../images/ui_buttons/style_formal.png';
import imgTro from '../images/ui_buttons/style_tropical.png';
import imgWW from '../images/ui_buttons/style_waterwise.png';
import backButton from '../images/ui_buttons/back_button.png';
import { Container, Group, Button, Card, Image, Text, Box } from '@mantine/core';
import StyleSelectorMobile from './StyleSelector.mobile';

const StyleSelector = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useAppContext();
  const { style } = state.currentDesign || {};
  const { navigateWithParams } = useUrlState();

  // Navigate to the next screen
  /* const handleNext = () => {
    console.log(state);
    navigate('/sunlight');
  }; */

  // Navigate to the previous screen
  const handleBack = () => {
    console.log(state);
    navigate('/house-editor');
  };

  // Logic for choosing selected style
  const handleSelectStyle = (styleId) => {
    console.log('StyleSelector received click on', styleId);
    dispatch({ type: SET_STYLE, payload: styleId });
    navigateWithParams('/sunlight', {
      zone: state.currentDesign?.zone,
      style: styleId,
      facade: state.currentDesign?.facade,
      houseSize: state.currentDesign?.houseSize,
      windows: state.currentDesign?.windows
    });
  };

  // Check if a style has been selected
  useEffect(() => {
    if (state.currentDesign?.style) {
      // Style is already selected, no need to set state
    }
  }, [state.currentDesign?.style]);

  const styleOptions = [
    { id: 'english', name: 'English', image: imgEng },
    { id: 'formal', name: 'Formal', image: imgFor },
    { id: 'tropical', name: 'Tropical', image: imgTro },
    { id: 'waterwise', name: 'Waterwise', image: imgWW },
  ];

  return (
    <>
      <BrowserView>
        <Container fluid p={0} style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
          <Box 
            height={100} 
            style={{ 
              backgroundColor: 'var(--header-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: '0 5px'
            }}
          >
            <Button
              variant="subtle"
              color="white"
              onClick={handleBack}
              style={{ 
                background: 'transparent', 
                border: 'none',
                padding: '8px',
                minWidth: 'auto',
                height: 'auto'
              }}
            >
              <Image 
                src={backButton} 
                alt="Back" 
                style={{ 
                  width: 'auto', 
                  height: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }} 
              />
            </Button>
            
            <Text size="xl" fw={600} c="white">
              Choose your Garden Style
            </Text>
            <div> </div>
            {/* <Button
              variant="subtle"
              color="white"
              onClick={handleNext}
              disabled={!isSelectionMade}
              style={{ 
                background: 'transparent', 
                border: 'none',
                opacity: isSelectionMade ? 1 : 0.5,
                padding: '8px',
                minWidth: 'auto',
                height: 'auto'
              }}
            >
              <Image 
                src={nextButton} 
                alt="Next" 
                style={{ 
                  width: 'auto', 
                  height: 'auto',
                  maxWidth: '100%',
                  maxHeight: '100%'
                }} 
              />
            </Button> */}
          </Box>
          
          <Box 
            style={{ 
              flex: 1,
              backgroundColor: 'var(--background-color)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '20px'
            }}
          >
            <Group gap="md" justify="center" align="center" wrap="nowrap">
              {styleOptions.map((option) => (
                <Card
                  key={option.id}
                  shadow="sm"
                  padding="xs"
                  radius="xl"
                  withBorder
                  style={{
                    width: '25%',
                    minWidth: '200px',
                    height: '600px',
                    backgroundColor: style === option.id ? 'var(--selected-color)' : 'var(--button-color)',
                    cursor: 'pointer',
                    transition: 'background-color 0.5s ease-in-out',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    paddingBottom: '100px'
                  }}
                  onClick={() => handleSelectStyle(option.id)}
                  onMouseEnter={(e) => {
                    if (style !== option.id) {
                      e.currentTarget.style.backgroundColor = 'var(--hover-color)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (style !== option.id) {
                      e.currentTarget.style.backgroundColor = 'var(--button-color)';
                    }
                  }}
                >
                  <Box style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Image
                      src={option.image}
                      alt={option.name}
                      style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                    />
                  </Box>
                  <Text fz={32} fw={"bold"} ta="center" c="black">
                    {option.name}
                  </Text>
                </Card>
              ))}
            </Group>
          </Box>
        </Container>
      </BrowserView>
      
      <MobileView>
        <StyleSelectorMobile
          selectedStyle={style}
          handleBack={handleBack}
          handleSelectStyle={handleSelectStyle}
        />
      </MobileView>
    </>
  );
};

export default StyleSelector;
